/**
 * DebugLoginReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * DebugLoginReq
 */
export interface DebugLoginReq {
  /** 管理员ID（id和username至少提供一个） */
  id?: string
  /** 管理员用户名（id和username至少提供一个） */
  username?: string
}

/**
 * DebugLoginReq Schema
 */
export const DebugLoginReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '管理员ID（id和username至少提供一个）',
      format: 'string',
      type: 'string',
      label: '管理员ID',
    },
    username: {
      description: '管理员用户名（id和username至少提供一个）',
      format: 'string',
      type: 'string',
      label: '管理员用户名',
    },
  },
  type: 'object',
}
